
import React from "react";

//icons
import { MdCreditScore } from "react-icons/md";
import { FaRegClock } from "react-icons/fa";
import { BiReceipt } from "react-icons/bi";


const ViewPaymentsSelectCard = ({ Title, Ammount, SubText, imageLink, colorOfIcon, setBackgroundSizeAndPosition,  }) => {
   //write a switch case to choose the icon according to the title passed
   let iconToSet;
   switch (Title) {
     case "View All Payments":
      iconToSet = <MdCreditScore fontSize={25} color={colorOfIcon} />;
       break;
     case  "Pending Payments":
      iconToSet = <FaRegClock fontSize={25} color={colorOfIcon} />;
       break;
     case "View unpaid invoices":
      iconToSet = <BiReceipt fontSize={25} color={colorOfIcon} />;
       break;
     default:
      iconToSet = <MdCreditScore fontSize={25} color={colorOfIcon} />;
   }



  const cardStyle = {
    width: "160px",
    height: "200px",
    marginBottom: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.28)",
    background: `url(${imageLink})`,
    backgroundSize: setBackgroundSizeAndPosition ? setBackgroundSizeAndPosition[0] : "auto",
    backgroundPosition: setBackgroundSizeAndPosition ? setBackgroundSizeAndPosition[1] : "left top",
    transition: "transform 0.3s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "10px",
    color: "white",
    fontFamily: "Poppins , sans-serif",
  };
  const top = {
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
  };
  const icon = {
    width: "40px",
    height: "40px",
    backgroundColor: "#FBFBFD",
    color: `#${colorOfIcon}`,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",


  };
  const title = {

    fontSize: "18px",
    fontWeight: "300",
    fontFamily : "Roboto, sans-serif",
    textAlign: "end",
    margin: "0px",
    maxWidth: "84px",
  };

  const bottom = {
    height: "30%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "end",
  }
  const amount = {
    fontSize: "20px",

  }
  const description = {
    fontSize: "16px",
    fontWeight: "300",
    fontFamily: "Roboto, sans-serif"
    
  }

 
  return (
    <div style={cardStyle}>
      <div style={top}>
        <div style={icon}>{iconToSet }</div>
        <div style={title}>{Title}</div>
      </div>
      <div style={bottom}>
        {/* <div style={amount}>{ Ammount}</div> */}
        <div style={description}>{ SubText}</div>
      </div>
    </div>
  );
};

export default ViewPaymentsSelectCard;
